import { createContext, useContext, useState, useCallback } from "react";
import { api, ADMIN_TOKEN_KEY } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem(ADMIN_TOKEN_KEY));
  const [username, setUsername] = useState(() => localStorage.getItem("samsi_admin_username"));

  const login = useCallback(async (u, p) => {
    const res = await api.post("/admin/login", { username: u, password: p });
    localStorage.setItem(ADMIN_TOKEN_KEY, res.data.token);
    localStorage.setItem("samsi_admin_username", res.data.username);
    setToken(res.data.token);
    setUsername(res.data.username);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(ADMIN_TOKEN_KEY);
    localStorage.removeItem("samsi_admin_username");
    setToken(null);
    setUsername(null);
  }, []);

  return (
    <AuthContext.Provider value={{ token, username, isAuthenticated: !!token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
